module.exports = __webpack_public_path__ + "static/r1-041e76c1178e7875262e3b2d4d88ec7d.jpg";